// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.role-detail {\n    padding:30px;\n    height:90%;\n}\n.role-detail-main {\n    width: 40%;\n    margin: auto;\n}\n.el-form-item__content {\n    text-align:left;\n}\n.el-checkbox {\n    width: 100%;\n    margin-right: 0px;\n}\n.check-permission {\n   /* width: 400px;*/\n    overflow: auto;\n    height: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
